import marilyn from "../../../image/originals/hollywoodicons/marilyn.jpg"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "86_base",
      name: "Marilyn Monroe Print",
      image: marilyn, // Main image without .webp
      price: "empty for now",
      thumbnails: [marilyn], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/MarilynMonroePrint",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
